import React, { useEffect, useState } from 'react';
import DataGridList from "../../components/CommonList/DataGridList.js";
import api from '../../services/api';

const Index = () => {
    const [Tokens, setTokens] = useState([]);

    const columns = [
        { name: 'Stream Token', index: 'token_name', type: 'text' },
        { name: 'Trigger Content', index: 'trigger_token_name', type: 'text' },
        { name: 'Label', index: 'label', type: 'text' },
        { name: 'Content Start', index: 'content_start', type: 'datetime' },
        { name: 'Content End', index: 'content_end', type: 'datetime' },
        { name: 'Enabled', index: 'is_active', type: 'input-switch' },
    ];

    const options = {
        crud: true,
        add: {
            route: "/manage/momenttrigger/form"
        },
        edit: {
            route: "/manage/momenttrigger/form"
        },
        details: {
            route: ""
        },
        delete: {
            route: "momenttrigger/"
        },
        enabledOpt: {
            url_edit: 'momenttrigger/',
            field: null
        },
        export: {
            route: ""
        },
    }

    const url = "momenttriggers"

    const filters = [
        { name: "Stream Token", index: 'token', type: 'dropdown', list: Tokens, placeholder: 'Stream Token' },
        { name: "Trigger Content", index: 'trigger_token', type: 'dropdown', list: Tokens, placeholder: 'Trigger Content' },
        { name: "Search", index: 'search', type: 'text' },
    ];

    const getTokens = async () => {
        try {
            api.get('tokens?limit=1000')
                .then(function (response) {
                    if (response.status == 200) {
                        setTokens(response.data.results);
                    }
                })
                .catch(function (error) {
                });
        } catch (err) {
        }
    }

    useEffect(() => {
        getTokens();
    }, []);

    return (
        <DataGridList url={url} columns={columns} options={options} filters={filters}/>
    );
};

export default Index;
